var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mast-head logo-wpr"},[_c('div',{staticClass:"logo-masthead",on:{"click":_vm.handleLogoClick}},[_c('img',_vm._b({},'img',_vm.config.logo,false))]),_c('flyer-validity-dates')],1)}
var staticRenderFns = []

export { render, staticRenderFns }